import React, { useEffect, useState, useRef } from "react";
import { API, graphqlOperation, Storage, Auth } from "aws-amplify";
import { useSelector } from "react-redux";
import AWS from "aws-sdk";
import AWSAppSyncClient from "aws-appsync";
import gql from "graphql-tag";
import { motion } from "framer-motion";

import {
  Box,
  Flex,
  Image,
  Icon,
  Text,
  Grid,
  GridItem,
  Card,
  Stack,
  CardBody,
  CardFooter,
  Heading,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Button,
  HStack,
  Tooltip,
  useToast,
  IconButton,
  Badge,
  TabPanel,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  CircularProgress,
  CircularProgressLabel,
  Center,
  useClipboard,
} from "@chakra-ui/react";
import applePay from "../../Assets/button-buy-with~dark@2x.png";
import { shouldShowLockButton } from "../../Helper/guestAppConfig";
import { IoIosArrowUp } from "react-icons/io";
import {
  BsPersonFillLock,
  BsFillTelephoneFill,
  BsBagPlusFill,
} from "react-icons/bs";
import { BiMenu } from "react-icons/bi";
import { FaBookOpen } from "react-icons/fa";
import { AiTwotoneLock, AiTwotoneUnlock } from "react-icons/ai";
import { BsPatchQuestionFill } from "react-icons/bs";

import { RiLockPasswordFill, RiDoorLockBoxFill } from "react-icons/ri";
import {
  MdWifi,
  MdCleaningServices,
  MdTour,
  MdNavigateNext,
} from "react-icons/md";
import { ImEnter, ImExit } from "react-icons/im";
import { FiCopy } from "react-icons/fi";
import {
  getRoom,
  guideRoomsByRoomId,
  getGuide,
  roomUpsellsByRoomID,
  getUpsell,
  getGuideCatalog,
} from "../../graphql/queries";
import { useNavigate, useLocation } from "react-router-dom";
import { GuideDisplay } from "../Mini/guide";
import { UpsellDisplay } from "../Mini/upsell";
import { UpsellBox } from "../Component/UpsellTile";
import { apiAuth } from "../../Backend/api";
import { MenuDisplay } from "../Mini/menu";
import { CiboModal } from "../Mini/ciboModal";
import { AboutModal } from "../Mini/aboutModal";
import { MountModal } from "../Mini/mountModal";
import { MountInfoModal } from "../Mini/mountInfoModal";
import { CheckInComponent } from "../Mini/checkInComponent";
import { ViatorModal } from "../Mini/viatorModal";

export const Main = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [manager, setManager] = useState(null);
  const toast = useToast();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();

  const {
    isOpen: isOpenCIBO,
    onOpen: onOpenCIBO,
    onClose: onCloseCIBO,
  } = useDisclosure();

  const {
    isOpen: isOpenMount,
    onOpen: onOpenMount,
    onClose: onCloseMount,
  } = useDisclosure();

  const {
    isOpen: isOpenViator,
    onOpen: onOpenViator,
    onClose: onCloseViator,
  } = useDisclosure();

  const {
    isOpen: isOpenMountAbout,
    onOpen: onOpenMountAbout,
    onClose: onCloseMountAbout,
  } = useDisclosure();

  const {
    isOpen: isOpenAbout,
    onOpen: onOpenAbout,
    onClose: onCloseAbout,
  } = useDisclosure();

  const location = useLocation();
  const { room, booking, storedStripeId } = location.state || {};
  const [showItem, setShowItem] = useState(false);
  const [roomDb, setRoomDb] = useState({});
  // const [doorLocked, setDoorLocked] = useState(true);
  const [doorLoading, setDoorLoading] = useState(false);
  const [doorState, setDoorState] = useState(true);

  // Same host setting as the v2 main screen. Bookings reaching this legacy
  // screen may predate the flag, in which case the control stays visible.
  const showLockButton = shouldShowLockButton(booking);

  const { hasCopied, onCopy } = useClipboard(roomDb.wifiPass || "");

  const [guide, setGuide] = useState({});
  const [guideCatalogList, setGuideCatalogList] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [guides, setGuides] = useState([]);
  const [filteredGuides, setFilteredGuides] = useState([]);

  const [upsells, setUpsells] = useState([]);
  const [upsell, setUpsell] = useState({});

  const EstimatedApiResponseTime = 5500;
  const [progress, setProgress] = useState(0);

  const [tooltipShown, setTooltipShown] = useState(false);
  const [guidesLoad, setGuidesLoad] = useState(true);

  const [loadingUpsells, setLoadingUpsells] = useState(true);

  const [defaultCurrency, setDefaultCurrency] = useState("USD");
  const [upsellPriceMap, setUpsellPriceMap] = useState({});

  const navigate = useNavigate();

  const handleCopy = () => {
    onCopy();
    toast({
      title: "Copied to clipboard",
      description: "Wi-Fi password has been copied.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  useEffect(() => {
    if (!room || !booking) {
      navigate("/auth");
    }

    const timer = setTimeout(() => {
      setShowItem(true);
    }, 5000); // 5000 milliseconds = 5 seconds

    return () => clearTimeout(timer);
  }, [room, booking, navigate, storedStripeId]);

  const handleBackButton = (event) => {
    event.preventDefault();
    navigate("/auth");
  };

  const handleLobbyAccess = () => {
    onOpenCIBO(); // Open the modal for lobby access
  };

  const handleMount = () => {
    onOpenMount(); // Open the modal for lobby access
  };

  const handleViator = () => {
    onOpenViator(); // Open the modal for lobby access
  };

  useEffect(() => {
    const selectedCategoryId = guideCatalogList[activeTabIndex]?.id;

    if (selectedCategoryId === "all" || !selectedCategoryId) {
      setFilteredGuides(guides);
    } else {
      const filtered = guides.filter(
        (guide) => guide.guideCatalogID === selectedCategoryId
      );
      setFilteredGuides(filtered);
    }
  }, [activeTabIndex, guides, guideCatalogList]);

  useEffect(() => {
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [location, navigate]);

  const query = gql`
    query GetUsers($id: String!) {
      getUsers(users: $id) {
        users
        stripeId
      }
    }
  `;

  const runQuery = async (id) => {
    const client = new AWSAppSyncClient({
      url: process.env.REACT_APP_URL,
      region: "us-west-2",
      auth: {
        type: "API_KEY",
        apiKey: process.env.REACT_APP_API_KEY,
      },
      disableOffline: "false",
    });

    try {
      const result = await client.query({
        query,
        variables: { id },
      });
      return result.data.getUsers;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchUser = async (id) => {
    try {
      const userData = await runQuery(id);
      setManager({ ...userData });
    } catch (error) {
      console.log("error fetching users", error);
    }
  };

  // useEffect(() => {
  //   getRoomItem(room.id);
  //   getGuidesByRoom(room.id);
  //   getUpsellsByRoom(room.id);
  // }, []);

  useEffect(() => {
    const initialize = async () => {
      if (!room?.id || !room.owner) return;

      getRoomItem(room.id);
      getGuidesByRoom(room.id);

      // Fetch manager first, then get upsells
      const userData = await runQuery(room.owner);
      if (userData) {
        setManager(userData);
        getUpsellsByRoom(room.id, userData); // <-- now pass the manager
      }
    };

    initialize();
  }, []);

  const getDefaultCurrency = async (manager) => {
    try {
      const response = await API.post("payStripe", "/pay/getDefaultCurrency", {
        body: { id: manager.stripeId },
      });

      if (response.currency) {
        setDefaultCurrency(response.currency.toUpperCase());
      } else {
        console.warn("Currency not found in response.");
      }
    } catch (error) {
      console.error("Failed to fetch default currency:", error);
    }
  };

  const fetchLockState = async () => {
    try {
      const response = await API.post("doorControl", "/door/getlock", {
        body: { deviceID: booking.deviceID },
      });
      if (response && response.body && response.body.properties) {
        setDoorState(response.body.properties.locked);
      } else {
        throw new Error("Failed to get lock status");
      }
    } catch (error) {
      console.error("Error fetching lock state:", error);
    }
  };

  useEffect(() => {
    if (booking.deviceID) {
      fetchLockState();
    }
  }, []);

  const getRoomItem = async (id) => {
    // console.log(id);

    const roomData = await API.graphql(graphqlOperation(getRoom, { id: id }));

    const user = await Auth.currentUserInfo();

    if (roomData.data.getRoom.ciboLink && user) {
      // Append formattedName to ciboLink

      //only for AMANDA
      // const updatedCiboLink = `${
      //   JSON.parse(roomData.data.getRoom.ciboLink).url
      // }${firstName}lxz${lastName}`;

      //       #if( $ctx.error )
      //   $util.error($ctx.error.message, $ctx.error.type)
      // #end
      // $util.toJson($ctx.result)

      const updatedCiboLink = `${
        JSON.parse(roomData.data.getRoom.ciboLink).url
      }${booking.reservationID}`;
      roomData.data.getRoom.ciboLink = updatedCiboLink;
    }

    if (!roomData.data.getRoom.pmsID) {
      const checkInImages = roomData.data.getRoom.checkIn.map(
        async (inItem) => {
          // Step photos are optional — don't sign an empty key.
          return { ...inItem, image: inItem.image ? await Storage.get(inItem.image) : "" };
        }
      );

      const checkOutImages = roomData.data.getRoom.checkOut.map(
        async (outItem) => {
          return { ...outItem, image: await Storage.get(outItem.image) };
        }
      );

      const roomImage = Storage.get(roomData.data.getRoom.images[0]);

      // Use Promise.all to resolve all promises
      const images = await Promise.all([
        ...checkInImages,
        ...checkOutImages,
        roomImage,
      ]);

      // Update checkIn, checkOut, and room images with resolved values from promises
      roomData.data.getRoom.checkIn = images.slice(
        0,
        roomData.data.getRoom.checkIn.length
      );
      roomData.data.getRoom.checkOut = images.slice(
        roomData.data.getRoom.checkIn.length,
        roomData.data.getRoom.checkIn.length +
          roomData.data.getRoom.checkOut.length
      );
      roomData.data.getRoom.images[0] = images[images.length - 1];
    }

    // fetchUser(roomData.data.getRoom.owner);
    setRoomDb(roomData.data.getRoom);
    // setData(false);
  };

  const getGuidesByRoom = async (id) => {
    const guideData = await API.graphql(
      graphqlOperation(guideRoomsByRoomId, {
        roomId: id,
      })
    );

    const guideRooms = guideData.data.guideRoomsByRoomId.items;

    const guidesDB = [];
    const guideCatalogIDs = new Set();

    for (const guideRoom of guideRooms) {
      const guideData = await API.graphql(
        graphqlOperation(getGuide, { id: guideRoom.guideId })
      );

      const guideItem = guideData.data.getGuide;
      
      // Use CloudFront URL for guide images (same as MainV2.js)
      if (guideItem.images?.[0]) {
        const imageKey = guideItem.images[0];
        
        // If it's already a full URL, use it directly
        if (imageKey.startsWith('http://') || imageKey.startsWith('https://')) {
          guideItem.images[0] = imageKey;
        } else {
          // Construct optimized CloudFront URL
          const cloudfrontBaseUrl = "https://dl6ri8ttf37m3.cloudfront.net";
          const optimizedUrl = `${cloudfrontBaseUrl}/public/${encodeURIComponent(imageKey)}?width=600&format=webp`;
          guideItem.images[0] = optimizedUrl;
        }
      }

      guidesDB.push(guideItem);

      if (guideItem.guideCatalogID) {
        guideCatalogIDs.add(guideItem.guideCatalogID);
      }
    }

    let guideCatalogItems = [];

    for (const guideCatalogID of guideCatalogIDs) {
      const guideCatalogData = await API.graphql(
        graphqlOperation(getGuideCatalog, { id: guideCatalogID })
      );
      const catalog = guideCatalogData.data.getGuideCatalog;
      if (catalog) {
        guideCatalogItems.push(catalog);
      }
    }

    // Add "All" as first tab
    guideCatalogItems.unshift({ name: "All", id: "all" });

    // Define priority order
    const PRIORITY_ORDER = {
      All: 0,
      "Resort Map": 1,
      "Resort Amenities": 2,
      "Resort Rules": 3,
    };

    // Sort by priority, others come after alphabetically
    guideCatalogItems = guideCatalogItems.sort((a, b) => {
      const aPriority = PRIORITY_ORDER[a.name] ?? 100;
      const bPriority = PRIORITY_ORDER[b.name] ?? 100;
      return aPriority - bPriority || a.name.localeCompare(b.name);
    });

    setGuideCatalogList(guideCatalogItems);
    setGuides(guidesDB);
    setGuidesLoad(false);
  };

  // const getGuidesByRoom = async (id) => {
  //   const guideData = await API.graphql(
  //     graphqlOperation(guideRoomsByRoomId, {
  //       roomId: id,
  //       // limit: 5,
  //     })
  //   );

  //   const guideRooms = guideData.data.guideRoomsByRoomId.items;

  //   const guidesDB = [];
  //   const guideCatalogIDs = new Set();

  //   for (const guideRoom of guideRooms) {
  //     const guideData = await API.graphql(
  //       graphqlOperation(getGuide, { id: guideRoom.guideId })
  //     );

  //     const guideItem = guideData.data.getGuide;
  //     guideItem.images[0] = await Storage.get(guideItem.images[0]);

  //     guidesDB.push(guideItem);

  //     if (guideItem.guideCatalogID) {
  //       guideCatalogIDs.add(guideItem.guideCatalogID);
  //     }
  //   }

  //   let guideCatalogItems = [{ name: "All", id: "all" }];

  //   for (const guideCatalogID of guideCatalogIDs) {
  //     const guideCatalogData = await API.graphql(
  //       graphqlOperation(getGuideCatalog, { id: guideCatalogID })
  //     );
  //     guideCatalogItems.push(guideCatalogData.data.getGuideCatalog);
  //   }

  //   setGuideCatalogList(guideCatalogItems);
  //   setGuides(guidesDB);
  //   setGuidesLoad(false);
  // };

  const getUpsellsByRoom = async (id, manager) => {
    setLoadingUpsells(true);

    try {
      if (manager?.stripeId) {
        await getDefaultCurrency(manager);
      }

      const upsellData = await API.graphql(
        graphqlOperation(roomUpsellsByRoomID, {
          roomID: id,
        })
      );

      const upsellRooms = upsellData.data.roomUpsellsByRoomID.items;
      let upsellsDB = [];

      for (const upsellRoom of upsellRooms) {
        const upsellData = await API.graphql(
          graphqlOperation(getUpsell, { id: upsellRoom.upsellID })
        );
        const upsellItem = upsellData.data.getUpsell;
        upsellsDB.push(upsellItem);
      }

      const priorityItems = upsellsDB.filter((upsell) =>
        ["Early Check-In", "Late Check-Out", "Late Checkout"].some((name) =>
          upsell.name.includes(name)
        )
      );

      const filteredItems = upsellsDB.filter(
        (upsell) =>
          !["Early Check-In", "Late Check-Out", "Late Checkout"].some((name) =>
            upsell.name.includes(name)
          )
      );

      upsellsDB = [...priorityItems, ...filteredItems];
      setUpsells(upsellsDB);

      const pricedIds = upsellsDB.filter((u) => u.price > 0).map((u) => u.id);
      if (pricedIds.length > 0) {
        try {
          const body = { upsellIds: pricedIds };
          if (booking?.checkInDate && booking?.checkOutDate) {
            const nights = Math.ceil(
              (new Date(booking.checkOutDate) - new Date(booking.checkInDate)) / (1000 * 60 * 60 * 24)
            );
            if (nights > 0) body.nights = nights;
          }
          const res = await apiAuth("/v2/upsells/payment/price-preview", body);
          if (res.success && res.data?.items) {
            const map = {};
            res.data.items.forEach((item) => { map[item.upsellId] = item; });
            setUpsellPriceMap(map);
          }
        } catch (previewErr) {
          console.error("Price preview fetch failed:", previewErr);
        }
      }
    } catch (error) {
      console.error("Error fetching upsells:", error);
    } finally {
      setLoadingUpsells(false);
    }
  };

  const handleGuide = (guide) => {
    setGuide(guide);
    // console.log(guide);
    onOpen();
  };

  const handleDoor = async () => {
    setDoorLoading(true);
    setProgress(0);

    const interval = 100;
    let elapsed = 0;
    const maxProgressBeforeCompletion = 90;

    const timer = setInterval(() => {
      elapsed += interval;
      const progressValue = Math.min(
        (elapsed / EstimatedApiResponseTime) * 100,
        maxProgressBeforeCompletion
      );
      setProgress(progressValue);
    }, interval);

    try {
      const now = new Date();
      const currentDate = new Date(
        now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
      );
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];

      console.log("Current Date (PST):", formattedCurrentDate);
      console.log("Booking Check-in Date:", booking.checkInDate);
      console.log("Booking Check-out Date:", booking.checkOutDate);

      // Parse booking dates for comparison
      const checkInDate = new Date(booking.checkInDate);
      const checkOutDate = new Date(booking.checkOutDate);

      // Check if the current date is within the booking dates
      if (currentDate < checkInDate || currentDate > checkOutDate) {
        console.log(
          "Action aborted: Current date is outside the booking's check-in and check-out dates."
        );
        clearInterval(timer);
        setProgress(0); // Reset progress since no action was taken
        setDoorLoading(false);
        return;
      }

      // If within date range, proceed with API call
      const action = doorState ? "unlock" : "lock";
      const apiName = "doorControl"; // replace with your API name
      const path = `/door/${action}`;
      const body = { deviceID: booking.deviceID }; // replace with actual device ID

      const response = await API.post(apiName, path, { body });

      await new Promise((resolve) =>
        setTimeout(resolve, EstimatedApiResponseTime)
      );

      console.log(response);

      setProgress(100);
      clearInterval(timer);

      // Toggle the door state
      setDoorState(!doorState);
    } catch (error) {
      console.error("Error toggling door state:", error);
    }

    setDoorLoading(false);
  };

  const handleUpsell = (upsell) => {
    setUpsell(upsell);
    onOpen2();
  };

  const isBeforeCheckInDate = () => {
    const currentDateTime = new Date();
    const checkInDateTime = new Date(booking.checkInDate);
    return currentDateTime < checkInDateTime;
  };

  useEffect(() => {
    if (isBeforeCheckInDate() && !tooltipShown) {
      setTooltipShown(true);
    }
  }, [tooltipShown]);

  const ProgressButton = ({ onClick, isLoading, progress, isLocked }) => {
    const disableButton = isLoading || isBeforeCheckInDate();

    const tooltipShownRef = useRef(false);

    // Update the ref only once when the condition is met
    if (isBeforeCheckInDate() && !tooltipShownRef.current && !isLoading) {
      tooltipShownRef.current = true;
    }
    const handleClick = () => {
      if (!disableButton) {
        onClick();
      }
    };

    return (
      <Tooltip
        label="Disabled until check in"
        fontSize={"12px"}
        placement="bottom"
        // isOpen={tooltipShownRef.current && disableButton}

        isOpen={isOpenAbout ? false : tooltipShownRef.current && disableButton}
      >
        <Button
          onClick={handleClick}
          bg={isLocked ? "#9ae6b4" : "#FBD38D"}
          h="42px"
          w="full"
          variant="solid"
          borderRadius="10px"
          fontSize="14px"
          color="#171923"
          position="relative"
          _active={{ bg: isLocked ? "#9ae6b4" : "#FBD38D" }}
          _hover={{ bg: isLocked ? "#9ae6b4" : "#FBD38D" }}
          disabled={disableButton}
        >
          {isLoading ? (
            <Flex justify="center" align="center" w="full" h="full">
              <CircularProgress value={progress} color="white" size="35px">
                <CircularProgressLabel fontSize={"10px"}>
                  {Math.round(progress)}
                </CircularProgressLabel>
              </CircularProgress>
            </Flex>
          ) : (
            <>
              <Icon as={isLocked ? AiTwotoneLock : AiTwotoneUnlock} mr={2} />
              {isLocked ? "Door Locked" : "Door Unlocked"}
            </>
          )}
        </Button>
      </Tooltip>
    );
  };

  const convertTimeTo12HourFormat = (timeString) => {
    if (!timeString) return;
    const [hours, minutes] = timeString.split(":");
    let formattedTime = "";

    if (hours < 12) {
      formattedTime = `${hours}:${minutes} AM`;
    } else if (hours === "12") {
      formattedTime = `${hours}:${minutes} PM`;
    } else {
      formattedTime = `${hours - 12}:${minutes} PM`;
    }

    return formattedTime;
  };

  const MotionButton = motion(Button);

  return (
    <Box>
      <Box position="relative">
        <Image
          src={roomDb.images}
          h={"280px"}
          w={"full"}
          objectFit={"cover"}
          // background="linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #1A202C 100%), url(.jpg), #D9D9D9;"
        />

        <Box
          position="absolute"
          top="2px"
          left="0"
          width="100%"
          height="100%"
          background="linear-gradient(180deg, rgb(0 0 0 / 0%) 0%, #1A202C 100%), transparent"
        />

        <Flex w="100%" top={5} position="absolute" px={2}>
          {room.id === "53a4a418-30ce-4737-9e1a-83463e988753" ? (
            <MotionButton
              leftIcon={<FaBookOpen />}
              h={"45px"}
              variant="solid"
              borderRadius={"20px"}
              fontSize={"12px"}
              _active={{ bg: "#615edc" }}
              _hover={{ bg: "#615edc" }}
              onClick={() => onOpenAbout()}
              animate={{
                backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
              }}
              transition={{
                duration: 10,
                ease: "easeInOut",
                loop: Infinity,
              }}
              background="linear-gradient(270deg, #ff7ea9, #d369d0, #ff6498)"
              backgroundSize="200% 200%"
              isLoading={doorLoading}
            >
              Property Guide
            </MotionButton>
          ) : (
            <Button
              leftIcon={<FaBookOpen />}
              bg={"#817EFF"}
              // isLoading={doorLoading}
              h={"45px"}
              variant="solid"
              borderRadius={"20px"}
              fontSize={"12px"}
              _active={{ bg: "#615edc" }}
              _hover={{ bg: "#615edc" }}
              onClick={() => onOpenAbout()}
            >
              Property Guide
            </Button>
          )}
        </Flex>

        <Flex
          w="100%"
          top={
            roomDb.address &&
            JSON.parse(roomDb.address).formatted_address.length > 55
              ? "74%"
              : "83%"
          }
          position="absolute"
          px={2}
        >
          <Text fontSize={"18px"} fontWeight={800}>
            {/* {roomDb.address &&
              JSON.parse(roomDb.address).formatted_address.length} */}
            {roomDb.address &&
              JSON.parse(roomDb.address)
                .formatted_address.split(",")
                .slice(0, -2)
                .join(",")}
          </Text>
        </Flex>
      </Box>
      {/* <Flex px={3} py={2} flexDirection="column">
        <Text fontSize={"12px"} fontWeight={800} color={"white"}>
          Interactivity
        </Text>

        <Button
          onClick={handleSelect}
          mt={3}
          color="white"
          bg={"#817EFF"}
          fontSize={"12px"}
          _hover={{ backgroundColor: "#504CFF" }}
          w={"full"}
          p={6}
          borderRadius={"60px"}
        >
          Check In Steps <Icon as={MdNavigateNext} fontSize={"22px"} />
        </Button>
      </Flex> */}

      <Button
        onClick={() => onOpenAbout()}
        bg={"#817efc"}
        mb={"10px"}
        color="white"
        h="42px"
        w="full"
        variant="solid"
        borderRadius="0px"
        fontSize="14px"
        rightIcon={<IoIosArrowUp />}
      >
        Explore the Property
      </Button>

      {/* LOCKS ARE ALWAYS SCHEDULED */}
      {(roomDb && roomDb.roomDeviceId && booking && booking.deviceID) ||
      (roomDb && roomDb.ciboLink) ? (
        <Flex px={4} py={2} flexDirection="column">
          <Text fontSize={"12px"} fontWeight={800} color={"white"}>
            Door Access
          </Text>
          <Grid templateColumns="repeat(2, 1fr)" w={"full"} gap={6} pt={4}>
            {roomDb && roomDb.roomDeviceId && booking && booking.deviceID && (
              <>
                {showLockButton && (
                  <GridItem>
                    <Text
                      fontSize={"12px"}
                      color={"#D0D0D0"}
                      fontWeight={600}
                      mb={"6px"}
                    >
                      Door Control
                    </Text>
                    <Flex alignItems={"start"}>
                      <ProgressButton
                        onClick={handleDoor}
                        isLoading={doorLoading}
                        progress={progress}
                        isLocked={doorState}
                      />
                    </Flex>
                  </GridItem>
                )}
                <GridItem>
                  <Icon as={RiDoorLockBoxFill} mr="2" fontSize={"20px"} />
                  <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
                    Door Lock Code
                  </Text>
                  <Text fontSize={"16px"} fontWeight={800}>
                    {booking.code ? booking.code : "No code available"}
                  </Text>
                </GridItem>
              </>
            )}

            {roomDb && roomDb.ciboLink && (
              <GridItem>
                <Text
                  fontSize={"12px"}
                  color={"#D0D0D0"}
                  fontWeight={600}
                  mb={"6px"}
                >
                  Lobby Access
                </Text>
                <Flex alignItems={"start"}>
                  <Button
                    onClick={handleLobbyAccess}
                    bg={"#817efc"}
                    color="white"
                    h="42px"
                    w="full"
                    variant="solid"
                    borderRadius="10px"
                    fontSize="14px"
                  >
                    Open Lobby
                  </Button>
                </Flex>
              </GridItem>
            )}
          </Grid>
        </Flex>
      ) : null}

      <Flex px={4} pt={3} pb={2} flexDirection="column">
        {/* {roomDb &&
          booking &&
          booking.status &&
          (() => {
            const status = booking.status;
            try {
              // Check if status is a string and needs parsing
              if (typeof status === "string") {
                const parsedStatus = JSON.parse(status);
                return parsedStatus.done === false;
              } else if (typeof status === "object") {
                // If status is already an object, use it directly
                return status.done === false;
              }
              return false; // Default to false if neither condition is met
            } catch (e) {
              console.error("Error parsing booking status:", e);
              return false; // Return false in case of parsing error or invalid format
            }
          })() && <CheckInComponent room={roomDb} booking={booking} />} */}

        {roomDb &&
          Array.isArray(roomDb.checkIn) &&
          roomDb.checkIn.length > 0 && (
            <CheckInComponent room={roomDb} booking={booking} />
          )}

        <Text fontSize={"12px"} fontWeight={800} color={"white"}>
          Information
        </Text>
        <Grid templateColumns="repeat(2, 1fr)" w={"full"} gap={6} pt={4}>
          {/* <GridItem>
            <Icon as={BsDoorOpenFill} mr="2" fontSize={"20px"} />
            <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
              Door Status
            </Text>

            {doorLocked ? (
              <Badge colorScheme="green">Locked</Badge>
            ) : (
              <Badge colorScheme="red">Unlocked</Badge>
            )}
          </GridItem> */}
          {/* <GridItem>
            <Icon as={BsFillTelephoneFill} mr="2" fontSize={"20px"} />
            <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
              Host Contact
            </Text>
            <Text fontSize={"16px"} fontWeight={800}>
              2502342932
            </Text>
          </GridItem> */}
          <GridItem>
            <Icon as={ImEnter} mr="2" fontSize={"20px"} />
            <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
              Check In Time
            </Text>
            <Text fontSize={"16px"} fontWeight={800}>
              {/* {roomDb.checkInTime} */}
              {roomDb && convertTimeTo12HourFormat(roomDb.checkInTime)}
            </Text>
          </GridItem>
          <GridItem>
            <Icon as={ImExit} mr="2" fontSize={"20px"} />
            <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
              Check Out Time
            </Text>
            <Text fontSize={"16px"} fontWeight={800}>
              {roomDb && convertTimeTo12HourFormat(roomDb.checkOutTime)}
            </Text>
          </GridItem>

          <GridItem>
            <Icon as={MdWifi} mr="2" fontSize={"20px"} />
            <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
              Wifi Network
            </Text>
            <Text fontSize={"16px"} fontWeight={800}>
              {roomDb.wifiName}
            </Text>
          </GridItem>
          <GridItem>
            <Icon as={RiLockPasswordFill} mr="2" fontSize={"20px"} />
            <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600}>
              Wifi Password
            </Text>
            <Flex align="center" gap={2}>
              <Text
                fontSize="16px"
                fontWeight={800}
                wordBreak="break-word"
                whiteSpace="pre-wrap"
                maxW="80%"
              >
                {roomDb.wifiPass}
              </Text>
              {roomDb.wifiPass && (
                <IconButton
                  icon={<FiCopy />}
                  size="sm"
                  aria-label="Copy WiFi password"
                  onClick={handleCopy}
                  bg="rgb(63, 68, 78)"
                  _hover={{ bg: "rgb(53, 58, 68)" }}
                  color="white"
                />
              )}
            </Flex>
          </GridItem>
        </Grid>
      </Flex>
      <Flex py={6} flexDirection="column">
        <Text px={3} fontSize={"12px"} fontWeight={800} pb={4}>
          Services
        </Text>

        <HStack
          spacing="10px"
          overflowX="auto"
          scrollBehavior="smooth"
          px={2}
          flexDirection="column"
          h="200px"
          flexWrap="wrap"
        >
          {loadingUpsells ? (
            <Center w="full" h="200px" flexDirection={"column"}>
              <CircularProgress
                mt={"20px"}
                isIndeterminate
                color="#504CFF"
                size={"30px"}
                trackColor="transparent"
              />
              <Text
                fontSize={"12px"}
                fontWeight={"900"}
                mt={"20px"}
                mb={"20px"}
              >
                Loading your upsells...
              </Text>
            </Center>
          ) : upsells.length === 0 ? (
            <Center w="full" h="100px">
              <Text fontSize="14px" color="gray.400" fontWeight={600}>
                No services available at this time.
              </Text>
            </Center>
          ) : (
            upsells.map((upsell, index) => (
              <UpsellBox
                key={index}
                upsell={upsell}
                defaultCurrency={defaultCurrency}
                pricePreview={upsellPriceMap[upsell.id]}
                onClick={() => handleUpsell(upsell)}
              />
            ))
          )}
        </HStack>
      </Flex>

      {roomDb && roomDb.viatorLink && (
        <Flex pt={2} pb={8} flexDirection="column">
          <Text px={3} fontSize={"12px"} fontWeight={800} pb={4}>
            Viator Experiences
          </Text>

          {roomDb && roomDb.viatorLink && (
            <Grid templateColumns="85% 15%" mx={2}>
              <GridItem mr={"5px"}>
                <Button
                  onClick={handleViator}
                  bg={"#817efc"}
                  color="white"
                  h="42px"
                  w="full"
                  variant="solid"
                  borderRadius="10px"
                  fontSize="14px"
                >
                  Explore Experiences
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  onClick={onOpenMountAbout}
                  bg={"#817efc"}
                  color="white"
                  h="42px"
                  w="full"
                  variant="solid"
                  borderRadius="10px"
                  fontSize="14px"
                >
                  <Icon as={BsPatchQuestionFill} fontSize={"20px"} />
                </Button>
              </GridItem>
            </Grid>
          )}
        </Flex>
      )}

      {roomDb &&
        roomDb.mountLinks &&
        roomDb.mountLinks.length > 0 &&
        !roomDb.mountLinks.some((link) => link === "" || link == null) && (
          <Flex pt={2} pb={8} flexDirection="column">
            <Text px={3} fontSize={"12px"} fontWeight={800} pb={4}>
              Local Experiences
            </Text>

            {roomDb && roomDb.mountLinks && (
              <Grid templateColumns="85% 15%" mx={2}>
                <GridItem mr={"5px"}>
                  <Button
                    onClick={handleMount}
                    bg={"#817efc"}
                    color="white"
                    h="42px"
                    w="full"
                    variant="solid"
                    borderRadius="10px"
                    fontSize="14px"
                  >
                    Explore Experiences
                  </Button>
                </GridItem>
                <GridItem>
                  <Button
                    onClick={onOpenMountAbout}
                    bg={"#817efc"}
                    color="white"
                    h="42px"
                    w="full"
                    variant="solid"
                    borderRadius="10px"
                    fontSize="14px"
                  >
                    <Icon as={BsPatchQuestionFill} fontSize={"20px"} />
                  </Button>
                </GridItem>
              </Grid>
            )}
          </Flex>
        )}

      {guidesLoad ||
      (guideCatalogList.length > 0 && filteredGuides.length > 0) ? (
        <Flex pt={1} pb={3} flexDirection="column">
          <Text fontSize={"12px"} px={4} fontWeight={800} pb={4}>
            Guides
          </Text>

          {guidesLoad ? (
            <Center flexDirection={"column"}>
              <CircularProgress
                mt={"20px"}
                isIndeterminate
                color="#504CFF"
                size={"30px"}
                trackColor="transparent"
              />
              <Text
                fontSize={"12px"}
                fontWeight={"900"}
                mt={"20px"}
                mb={"20px"}
              >
                Loading your guides...
              </Text>
            </Center>
          ) : (
            <Tabs
              variant="soft-rounded"
              isLazy
              onChange={(index) => setActiveTabIndex(index)}
            >
              <Box overflowX="auto">
                <TabList whiteSpace="nowrap" mb={4} mx={4}>
                  {guideCatalogList.map((category) => (
                    <Tab
                      key={category.id}
                      fontSize="12px"
                      color="grey"
                      _selected={
                        room.id === "53a4a418-30ce-4737-9e1a-83463e988753"
                          ? { color: "white", bg: "#ff6498" }
                          : { color: "white", bg: "#817EFF" }
                      }
                    >
                      {category.name}
                    </Tab>
                  ))}
                </TabList>
              </Box>

              <TabPanels px={4}>
                {guideCatalogList.map((category, index) => (
                  <TabPanel key={category.id} p={1}>
                    {filteredGuides
                      .filter(
                        (guide) =>
                          index === 0 || guide.guideCatalogID === category.id
                      )
                      .map((guide, idx) => (
                        <Card
                          mb={4}
                          direction={"row"}
                          overflow="hidden"
                          variant="outline"
                          onClick={() => handleGuide(guide)}
                          key={idx}
                        >
                          <Image
                            objectFit="cover"
                            h={"95px"}
                            w={"120px"}
                            src={guide.images[0]}
                            alt={guide.title}
                          />
                          <Flex h={"95px"} alignItems="center">
                            <CardBody>
                              <Heading size="md">{guide.title}</Heading>
                            </CardBody>
                          </Flex>
                        </Card>
                      ))}
                  </TabPanel>
                ))}
              </TabPanels>
            </Tabs>
          )}
        </Flex>
      ) : null}

      {/* {guideCatalogList.length > 0 &&
        guideCatalogList.some((category) =>
          filteredGuides.some((guide) => guide.guideCatalogID === category.id)
        ) && (
          <Flex pt={1} pb={3} flexDirection="column">
            <Text fontSize={"12px"} px={4} fontWeight={800} pb={4}>
              Guides
            </Text>

            {!guidesLoad ? (
              <Center flexDirection={"column"}>
                <CircularProgress
                  mt={"20px"}
                  isIndeterminate
                  color="#504CFF"
                  size={"30px"}
                  trackColor="transparent"
                />
                <Text fontSize={"12px"} fontWeight={"900"} mt={"20px"}>
                  Loading your guides...
                </Text>
              </Center>
            ) : (
              <Tabs
                variant="soft-rounded"
                isLazy
                onChange={(index) => setActiveTabIndex(index)}
              >
                <Box overflowX="auto">
                  <TabList whiteSpace="nowrap" mb={4} mx={4}>
                    {guideCatalogList.map((category) => (
                      <Tab
                        key={category.id}
                        fontSize="12px"
                        color="grey"
                        _selected={
                          room.id === "53a4a418-30ce-4737-9e1a-83463e988753"
                            ? { color: "white", bg: "#ff6498" }
                            : { color: "white", bg: "#817EFF" }
                        }
                      >
                        {category.name}
                      </Tab>
                    ))}
                  </TabList>
                </Box>

                <TabPanels px={4}>
                  {guideCatalogList.map((category, index) => (
                    <TabPanel key={category.id} p={1}>
                      {filteredGuides
                        .filter(
                          (guide) =>
                            index === 0 || guide.guideCatalogID === category.id
                        )
                        .map((guide, idx) => (
                          <Card
                            mb={4}
                            direction={"row"}
                            overflow="hidden"
                            variant="outline"
                            onClick={() => handleGuide(guide)}
                            key={idx}
                          >
                            <Image
                              objectFit="cover"
                              h={"95px"}
                              w={"120px"}
                              src={guide.images[0]}
                              alt={guide.title}
                            />
                            <Flex h={"95px"} alignItems="center">
                              <CardBody>
                                <Heading size="md">{guide.title}</Heading>
                              </CardBody>
                            </Flex>
                          </Card>
                        ))}
                    </TabPanel>
                  ))}
                </TabPanels>
              </Tabs>
            )}
          </Flex>
        )} */}

      {/* <Drawer placement={"bottom"} onClose={onClose3} isOpen={isOpen3}>
        <DrawerOverlay />
        <DrawerContent maxH={"90vh"}>
          <DrawerCloseButton />
          <DrawerHeader>Early Check In</DrawerHeader>
          <DrawerBody p={0}>
            <Text px={4} pb={10}>
              Check in early into your unit a few days in advance if no prior
              bookings are made
            </Text>
          </DrawerBody>

          <DrawerFooter>
            <Grid
              templateColumns="40% 60%"
              w={"full"}
              gap={2}
              alignItems="center"
            >
              <Text fontSize={"20px"} fontWeight={800}>
                $12.00
              </Text>
              <Image
                src={applePay}
                onClick={() => console.log("selected")}
                // h={"40px"}
                borderRadius={"10px"}
              />
            </Grid>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Drawer placement={"bottom"} onClose={onClose4} isOpen={isOpen4}>
        <DrawerOverlay />
        <DrawerContent maxH={"90vh"}>
          <DrawerCloseButton />
          <DrawerHeader>Late Check Out</DrawerHeader>
          <DrawerBody p={0}>
            <Text px={4} pb={10}>
              Check out late from your unit a few days after your booking if
              there are no following bookings
            </Text>
          </DrawerBody>

          <DrawerFooter>
            <Grid
              templateColumns="40% 60%"
              w={"full"}
              gap={2}
              alignItems="center"
            >
              <Text fontSize={"20px"} fontWeight={800}>
                $24.00
              </Text>
              <Image
                src={applePay}
                onClick={() => console.log("selected")}
                // h={"40px"}
                borderRadius={"10px"}
              />
            </Grid>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Drawer placement={"bottom"} onClose={onClose5} isOpen={isOpen5}>
        <DrawerOverlay />
        <DrawerContent maxH={"90vh"}>
          <DrawerCloseButton />
          <DrawerHeader>Mid Stay Clean</DrawerHeader>
          <DrawerBody p={0}>
            <Text px={4} pb={10}>
              Have a cleaning service done during your stay in your unit
            </Text>
          </DrawerBody>

          <DrawerFooter>
            <Grid
              templateColumns="40% 60%"
              w={"full"}
              gap={2}
              alignItems="center"
            >
              <Text fontSize={"20px"} fontWeight={800}>
                $35.00
              </Text>
              <Image
                src={applePay}
                onClick={() => console.log("selected")}
                // h={"40px"}
                borderRadius={"10px"}
              />
            </Grid>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Drawer placement={"bottom"} onClose={onClose6} isOpen={isOpen6}>
        <DrawerOverlay />
        <DrawerContent maxH={"90vh"}>
          <DrawerCloseButton />
          <DrawerHeader>Guide Tours</DrawerHeader>
          <DrawerBody p={0}>
            <Text px={4} pb={10}>
              Take a wine tour throughout the Okanagan with wine tasting and
              greate sceneries
            </Text>
          </DrawerBody>

          <DrawerFooter>
            <Grid
              templateColumns="40% 60%"
              w={"full"}
              gap={2}
              alignItems="center"
            >
              <Text fontSize={"20px"} fontWeight={800}>
                $120.00
              </Text>
              <Image
                src={applePay}
                onClick={() => console.log("selected")}
                // h={"40px"}
                borderRadius={"10px"}
              />
            </Grid>
          </DrawerFooter>
        </DrawerContent>
      </Drawer> */}
      {/* <Box>
        <IconButton
          icon={<IoIosAdd />}
          bg={"#817EFF"}
          position="fixed"
          variant="solid"
          right={6}
          bottom={10}
          size="lg"
        />
      </Box> */}

      <Button
        leftIcon={<BiMenu />}
        bg={"#817EFF"}
        right={4}
        top={5}
        // isLoading={doorLoading}
        h={"45px"}
        position="fixed"
        variant="solid"
        borderRadius={"20px"}
        fontSize={"12px"}
        _active={{ bg: "#615edc" }}
        _hover={{ bg: "#615edc" }}
        onClick={() => onOpen3()}
      >
        Menu
      </Button>

      {room.id === "53a4a418-30ce-4737-9e1a-83463e988753" ? (
        <MotionButton
          leftIcon={<BiMenu />}
          bg={"#817EFF"}
          right={4}
          top={5}
          // isLoading={doorLoading}
          h={"45px"}
          position="fixed"
          variant="solid"
          borderRadius={"20px"}
          fontSize={"12px"}
          _active={{ bg: "#615edc" }}
          _hover={{ bg: "#615edc" }}
          onClick={() => onOpen3()}
          animate={{
            backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
          }}
          transition={{
            duration: 10,
            ease: "easeInOut",
            loop: Infinity,
          }}
          background="linear-gradient(270deg, #ff7ea9, #d369d0, #ff6498)"
          backgroundSize="200% 200%"
        >
          Menu
        </MotionButton>
      ) : (
        <Button
          leftIcon={<BiMenu />}
          bg={"#817EFF"}
          right={4}
          top={5}
          // isLoading={doorLoading}
          h={"45px"}
          position="fixed"
          variant="solid"
          borderRadius={"20px"}
          fontSize={"12px"}
          _active={{ bg: "#615edc" }}
          _hover={{ bg: "#615edc" }}
          onClick={() => onOpen3()}
        >
          Menu
        </Button>
      )}

      {/* <Button
        leftIcon={<AiTwotoneLock />}
        bg={"#817EFF"}
        right={6}
        bottom={10}
        isLoading={doorLoading}
        h={"45px"}
        position="fixed"
        variant="solid"
        borderRadius={"20px"}
        fontSize={"14px"}
        _active={{ bg: "#615edc" }}
        _hover={{ bg: "#615edc" }}
        onClick={handleDoor}
      >
        Door Lock
      </Button> */}
      <MenuDisplay
        onClose={onClose3}
        isOpen={isOpen3}
        aboutOpen={onOpenAbout}
        room={roomDb}
        booking={booking}
      />
      <GuideDisplay guide={guide} onClose={onClose} isOpen={isOpen} />
      <AboutModal onClose={onCloseAbout} isOpen={isOpenAbout} room={roomDb} />
      {roomDb.ciboLink && (
        <CiboModal
          onClose={onCloseCIBO}
          isOpen={isOpenCIBO}
          link={roomDb.ciboLink}
        />
      )}

      {roomDb.viatorLink && (
        <ViatorModal
          onClose={onCloseViator}
          isOpen={isOpenViator}
          id={roomDb.viatorLink}
        />
      )}

      {roomDb.viatorLink && (
        <MountInfoModal onClose={onCloseMountAbout} isOpen={isOpenMountAbout} />
      )}

      {roomDb.mountLinks && (
        <MountModal
          onClose={onCloseMount}
          isOpen={isOpenMount}
          link={roomDb.mountLinks[0]}
        />
      )}

      {roomDb.mountLinks && (
        <MountInfoModal onClose={onCloseMountAbout} isOpen={isOpenMountAbout} />
      )}

      {manager && (
        <UpsellDisplay
          upsell={upsell}
          booking={booking}
          manager={manager}
          onClose={onClose2}
          isOpen={isOpen2}
          defaultCurrency={defaultCurrency}
          pricePreview={upsellPriceMap[upsell?.id]}
        />
      )}
    </Box>
  );
};

export default Main;
